@if (loaded) {
<div class="vertical-and-horizontal-center">
  <img [class]="`payment-options-icon ${paymentResponse.paymentProvider}`" width="70"
    [src]="getPaymentOptionIconUrlByType(paymentResponse.paymentProvider)" />

  @if (successPayment) {
  <div>
    <span class="mdi mdi-check-circle-outline success-icon"></span>
    <br>
    <span class="success-title">
      {{"shopping.payment_success_title" | translate}}
    </span>
    <br>
    <span class="success-text">
      {{"shopping.payment_success_text" | translate}}
      <!--<br /> 
          {{paymentResponse.paymentStatusMessage}}-->
    </span>
  </div>
  } @else {
  <div>
    <span class="mdi mdi-close-circle-outline error-icon"></span>
    <br>
    <span class="error-title">
      {{"shopping.payment_error_title" | translate}}
    </span>
    <br>
    <span class="error-text">
      <!--{{"shopping.payment_error_text" | translate}}
          <br />-->
      {{paymentResponse.paymentStatusMessage}}
    </span>
  </div>
  }

  <br>
  <div class="transaction-text hw-padding-10px">
    <div class="hw-font-weight-700 hw-margin-bottom-5px">{{"shopping.transactionId" | translate}}</div>
    <div>{{transactionId}}</div>
  </div>

  @if(paymentResponse.paymentProvider === "OTPSimple" && paymentResponse.providerTransactionId){
  <br>
  <div class="transaction-text hw-padding-10px">
    <div class="hw-font-weight-700 hw-margin-bottom-5px">{{"shopping.otpSimplepaytransactionId" | translate}}</div>
    <div>{{paymentResponse.providerTransactionId}}</div>
  </div>
  }

  <br>
  <br>

  @if (successPayment) {
  <button mat-raised-button color="primary" (click)="backToDealerWebsite()" class="next-button-style">
    {{"shopping.back_to_dealer_website" | translate}}</button>
  }
  @if (!successPayment) {
  <button mat-raised-button color="primary" (click)="backToSummaryPage()" class="next-button-style">
    {{"shopping.back_to_website" | translate}}</button>
  }

  <div class="flex flex-row">
    <div class="tel-header">
      <p>{{"shopping.support" | translate}}:</p>
      <a mat-raised-button class="hw-mat-tel-btn" [href]="'tel:' + subscriberInfo.contacts.PhoneNumber">
        <mat-icon>phone</mat-icon>
        {{subscriberInfo.contacts.PhoneNumber}}
      </a>
    </div>
  </div>
</div>
}